import React, { useEffect, useState } from "react"
import { useSession } from "../../hooks/auth/useSession.hook"
import { getTeamMembers } from "../../services/teamMember.service"
import useMount from "../../hooks/useMount"
import _ from "lodash"
import MultiSelect from "../atoms/MultiSelect.atom"
import { generateRandomId } from "../../utils/strings.utils"

const TeamMemberMultiselect = ({
  selectedTeamMembers,
  setSelectedTeamMembers,
  initiallySelected,
  filterByTeamAreaId, 
  placeholder = "Selecciona un miembro",
  optionLabel = "name",
  id = `team-member-multiselect-${generateRandomId()}`,
  showNotActive = false,
  maxSelectedLabels = 1,
  scrollHeight,
  ...props
}) => {
  const [options, setOptions] = useState([])
  const auth = useSession()
  const groupProps =
    showNotActive ?
      { optionGroupLabel: "label", optionGroupChildren: "items" }
    : {}

  selectedTeamMembers = selectedTeamMembers?.map((member) => parseInt(member))
  useEffect(() => {
    if (!selectedTeamMembers && initiallySelected) {
      setSelectedTeamMembers(initiallySelected(options))
    }
  }, [selectedTeamMembers, initiallySelected, options])

  useMount(fetchTeamMembers)

  async function fetchTeamMembers() {
    const response = await getTeamMembers()
    if (response.success) {
      let result = response.result

      if (filterByTeamAreaId) {
        result = result.filter(
          (member) => member.teamAreaId === filterByTeamAreaId
        )
      }
      if (showNotActive) {
        const groupedData = _.groupBy(result, "active")
        const groupedOptions = [
          { label: "Activos", items: groupedData["1"] || [] },
          { label: "Inactivos", items: groupedData["0"] || [] },
        ]
        setOptions(buildOptionsWithFullLabel(groupedOptions))
      } else {
        const activeTeamMembers = result.filter(
          (member) => member.active || selectedTeamMembers?.includes(member.id)
        )
        setOptions(buildOptionsWithFullLabel(activeTeamMembers))
      }

      if (!auth.user.isAdmin()) {
        const teamMemberData = result.find(
          (member) => member.id === auth.user.id
        )
        setSelectedTeamMembers(teamMemberData)
      }
    }
  }
  const getValidOptions = (options) => {
    if (showNotActive) {
      return options.flatMap((option) => option.items)
    }
    return options
  }

  const buildOptionsWithFullLabel = (options) => {
    return options.map((option) => ({
      ...option,
      fullLabel: `${option.nameTag} - ${option.name} ${option.lastName}`,
    }))
  }

  const itemTemplate = (item) => (
    <div className="overflow-hidden white-space-nowrap w-full text-overflow-ellipsis">
      <i className="pi pi-user mr-2"></i>
      <span>{item?.nameTag} - </span>
      <span>
        {item?.name} {item?.lastName}
      </span>
    </div>
  )
  return (
    <MultiSelect
      inputId={id}
      options={options}
      value={selectedTeamMembers}
      onChange={(e) => {
        const validOptions = getValidOptions(options)
        const selectedOptions = validOptions
          .filter((option) => e.value.includes(option?.[props.optionValue]))
          .reduce((acc, curr) => {
            acc.push(curr.id)
            return acc
          }, [])
        setSelectedTeamMembers(selectedOptions, options)
      }}
      panelClassName="team-member-multiselect-panel max-w-23rem"
      scrollHeight={scrollHeight || "417px"}
      optionLabel={optionLabel}
      placeholder={placeholder}
      {...groupProps}
      itemTemplate={itemTemplate}
      maxSelectedLabels={maxSelectedLabels}
      selectedItemsLabel="{0} integrantes seleccionados"
      selectedItemTemplate={(value) => {
        if (!value) return placeholder
        if (value.length > maxSelectedLabels) {
          return `${value.length} integrantes seleccionados`
        }
        const validOptions = getValidOptions(options)
        const selectedOption = validOptions.find(
          (option) => option.id === value
        )
        return itemTemplate(selectedOption)
      }}
      filter
      filterBy="fullLabel"
      emptyFilterMessage="Sin resultados ¿Seguro que trabaja aquí?"
      disabled={options.length === 0}
      {...props}
    />
  )
}

export default TeamMemberMultiselect
